import { module } from 'angular';
import { AuthService } from './auth/auth.service';
import { ProfileService } from './profile/profile.service';
import { RoleService } from './role/role.service';
import { CountryService } from './country/country-service';
import { MailService } from './mail/mail.service';
import { PasswordService } from './password/password.service';
import { LanguageService } from './language/language.service';
import { CurrencyService } from './currency/currency.service';
import { JobRankService } from './job-rank/job-rank.service';
import { JobPositionService } from './job-position/job-position.service';
import { ToastrService } from './toastr/toastr.service';
import { PlanService } from './plan/plan.service';
import { PaymentService } from './payment/payment.service';
import { UserService } from './user/user.service';
import { DomService } from './dom/dom.service';
import { ObjectUtilsService } from './object-utils/object-utils.service';
import { ApiService } from './api-service/api.service';
import { CandidateService } from './candidate/candidate.service';
import { WebsocketService } from './websocket/websocket.service';
import { EmployerService } from './employer/employer.service';
import { SmartServicesService } from './smart-services/smart-services.service';
import { CvService } from './cv.service';
import { AccessService } from './access.service';
import {VacancyService} from './vacancy/vacancy.service';
import {ApplicantService} from './applicant/applicant.service';
import { TopCvService } from './cv/cv.service';
import { ChatService } from '../../states/chat/services/chat-service';

export const CoreServicesModule = module('app.core.services', [])
  .service(ChatService.name, ChatService)
  .service(ApiService.name, ApiService)
  .service(WebsocketService.name, WebsocketService)
  .service(ToastrService.name, ToastrService)
  .service(AuthService.name, AuthService)
  .service(PasswordService.name, PasswordService)
  .service(ProfileService.name, ProfileService)
  .service(RoleService.name, RoleService)
  .service(CountryService.name, CountryService)
  .service(MailService.name, MailService)
  .service(LanguageService.name, LanguageService)
  .service(CurrencyService.name, CurrencyService)
  .service(JobRankService.name, JobRankService)
  .service(JobPositionService.name, JobPositionService)
  .service(PlanService.name, PlanService)
  .service(PaymentService.name, PaymentService)
  .service(UserService.name, UserService)
  .service(DomService.name, DomService)
  .service(ObjectUtilsService.name, ObjectUtilsService)
  .service(CandidateService.name, CandidateService)
  .service(EmployerService.name, EmployerService)
  .service(CvService.name, CvService)
  .service(EmployerService.name, EmployerService)
  .service(SmartServicesService.name, SmartServicesService)
  .service(AccessService.name, AccessService)
  .service(VacancyService.name, VacancyService)
  .service(TopCvService.name, TopCvService)
  .service(ApplicantService.name, ApplicantService);



// WEBPACK FOOTER //
// ./app/core/services/core-services.module.ts